import styled from '@emotion/styled'
import { colors, radius } from '@mobi/component-library/Foundations'
import type { SportIconSize } from '../../types'

export const IconWrapperStyled = styled.span<{ 'data-size': SportIconSize }>({
  boxSizing: 'border-box',

  '--size': '2.8rem',
  '--stroke': '0.2rem',

  width: 'var(--size)',
  height: 'var(--size)',

  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
  alignItems: 'center',
  overflow: 'hidden',
  border: 'var(--stroke) solid ' + colors.white,
  background: colors.white,

  ':empty': { display: 'none' },

  '> img': { width: '100%', height: 'auto' },
  '> span': { maxWidth: '100%' },

  '&[data-size="xxs"]': {
    '--size': '1.6rem',
    '--stroke': '0.133rem',
    borderRadius: radius.sm,
    filter:
      'drop-shadow(0 0.714px 1.429px rgba(26, 14, 35, 0.06)) drop-shadow(0 0.714px 2.143px rgba(26, 14, 35, 0.10))',
  },

  '&[data-size="xs"]': {
    '--size': '2rem',
    '--stroke': '0.166rem',
    borderRadius: radius.md,
    filter:
      'drop-shadow(0 0.714px 1.429px rgba(26, 14, 35, 0.06)) drop-shadow(0 0.714px 2.143px rgba(26, 14, 35, 0.10))',
  },

  '&[data-size="sm"]': {
    '--size': '2.4rem',
    '--stroke': '0.166rem',
    borderRadius: radius.md,
    filter:
      'drop-shadow(0 0.857px 1.714px rgba(26, 14, 35, 0.06)) drop-shadow(0 0.857px 2.571px rgba(26, 14, 35, 0.10))',
  },

  '&[data-size="md"]': {
    '--size': '2.8rem',
    '--stroke': '0.2rem',
    borderRadius: radius.lg,
    filter:
      'drop-shadow(0 1px 2px rgba(26, 14, 35, 0.06)) drop-shadow(0 1px 3px rgba(26, 14, 35, 0.10))',
  },

  '&[data-size="lg"]': {
    '--size': '3.2rem',
    '--stroke': '0.2rem',
    borderRadius: radius.lgx1,
    filter:
      'drop-shadow(0 1.143px 2.286px rgba(26, 14, 35, 0.06)) drop-shadow(0 1.143px 3.429px rgba(26, 14, 35, 0.10))',
  },

  '&[data-size="xl"]': {
    '--size': '3.6rem',
    '--stroke': '0.233rem',
    borderRadius: radius.lgx1,
    filter:
      'drop-shadow(0 1.286px 2.571px rgba(26, 14, 35, 0.06)) drop-shadow(0 1.286px 3.857px rgba(26, 14, 35, 0.10))',
  },
})
